import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class NumberDisplayComponent extends React.Component {
    render() {
        const { i18n, isCodePromo, partners } = this.props;
        let texte;
        const nombre = isCodePromo
            ? partners.reduce((res, curr) => res + curr.couponCount, 0)
            : partners.length;
        const s = nombre > 1 ? 's' : '';
        if (isCodePromo) {
            texte = `${i18n.REDUCTION.CODE}${s}`;
        } else {
            texte = nombre > 1 ? i18n.CASHBACK.MERCHANTS : i18n.CASHBACK.MERCHANT;
        }
        return (
            <div className="nombre-partenaires">
                <strong>{nombre}</strong> {texte}
            </div>
        );
    }
}

NumberDisplayComponent.propTypes = {
    isCodePromo: PropTypes.bool,
    partners: PropTypes.array
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.DIRECTORY
    };
};

export default connect(mapStateToProps)(NumberDisplayComponent);



// WEBPACK FOOTER //
// ./src/components/pages/directory/filter/NumberDisplayComponent.js